// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Tenant } from "./Tenant";
import { TenantFromJSON, TenantFromJSONTyped, TenantToJSON, TenantToJSONTyped } from "./Tenant";
import type { StorageTotals } from "./StorageTotals";
import {
  StorageTotalsFromJSON,
  StorageTotalsFromJSONTyped,
  StorageTotalsToJSON,
  StorageTotalsToJSONTyped,
} from "./StorageTotals";
import type { ProjectId } from "./ProjectId";
import {
  ProjectIdFromJSON,
  ProjectIdFromJSONTyped,
  ProjectIdToJSON,
  ProjectIdToJSONTyped,
} from "./ProjectId";

/**
 *
 * @export
 * @interface ProjectDailyUsage
 */
export interface ProjectDailyUsage {
  /**
   *
   */
  tenant: Tenant;
  /**
   *
   */
  projectId: ProjectId;
  /**
   *
   */
  usageDate: Date;
  /**
   *
   */
  storage: StorageTotals;
}

/**
 * Check if a given object implements the ProjectDailyUsage interface.
 */
export function instanceOfProjectDailyUsage(value: object): value is ProjectDailyUsage {
  if (!("tenant" in value) || value["tenant"] === undefined) return false;
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (
    (!("usageDate" in (value as Record<string, any>)) &&
      !("usage_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["usageDate"] === undefined &&
      (value as Record<string, any>)["usage_date"] === undefined)
  )
    return false;
  if (!("storage" in value) || value["storage"] === undefined) return false;
  return true;
}

export function ProjectDailyUsageFromJSON(json: any): ProjectDailyUsage {
  return ProjectDailyUsageFromJSONTyped(json, false);
}

export function ProjectDailyUsageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProjectDailyUsage {
  if (json == null) {
    return json;
  }
  return {
    tenant: TenantFromJSON(json["tenant"]),
    projectId: ProjectIdFromJSON(json["project_id"]),
    usageDate: json["usage_date"] == null ? json["usage_date"] : parseDate(json["usage_date"]),
    storage: StorageTotalsFromJSON(json["storage"]),
  };
}

export function ProjectDailyUsageToJSON(json: any): ProjectDailyUsage {
  return ProjectDailyUsageToJSONTyped(json, false);
}

export function ProjectDailyUsageToJSONTyped(
  value?: ProjectDailyUsage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tenant: TenantToJSON(value["tenant"]),
    project_id: ProjectIdToJSON(value["projectId"]),
    usage_date: value["usageDate"] == null ? value["usageDate"] : serializeDate(value["usageDate"]),
    storage: StorageTotalsToJSON(value["storage"]),
  };
}
